import KBBInlineRatings from './KBBInlineRatings';

export default KBBInlineRatings;
